import { UserCircle as ProfileCircleIcon } from "@phosphor-icons/react"

export default ProfileCircleIcon
